export default __webpack_public_path__ + "static/media/egg.b3ec06d7.svg";